"use strict";

/**
    Function to display the popover when the user icon is hovered
    */

let init = () => {
    let $userAccountIcon = $(".user");
    let $accountPopover = $(".account-popover");
    let $accountPopoverLink = $(".js-account-popover");
    let $accountPopoverItems = $accountPopover.find("a[role='menuitem']");
    let $minicartPopover = $(".minicart-popover");
    let isEscapeKey = (event) => event.key === "Escape" || event.key === "Esc" || event.keyCode === 27;
    let isArrowDownKey = (event) => event.key === "ArrowDown" || event.keyCode === 40;
    let isArrowUpKey = (event) => event.key === "ArrowUp" || event.keyCode === 38;

    let setPopoverState = (isOpen) => {
        $accountPopover.toggleClass("show", isOpen);
        $accountPopover.attr("aria-hidden", !isOpen);
        $accountPopoverLink.toggleClass("active", isOpen);
        $accountPopoverLink.attr("aria-expanded", isOpen);
        $accountPopover.find("[role='menu']").attr("aria-hidden", !isOpen);
        $accountPopoverItems.attr("tabindex", isOpen ? "0" : "-1");
    };

    setPopoverState(false);

    $userAccountIcon.on("mouseenter focusin touchstart", function () {
        if ($minicartPopover.length && $minicartPopover.hasClass("show")) {
            $minicartPopover.find(".js-minicart-close").trigger("click");
        }

        if (!$accountPopover.hasClass("show")) {
            setPopoverState(true);
        }
    });

    $("body").on("touchstart click", function (e) {
        if ($userAccountIcon.has(e.target).length <= 0) {
            setPopoverState(false);
        }
    });

    $userAccountIcon.on("mouseleave focusout", function (event) {
        let $nextFocusTarget = $(event.relatedTarget);

        if (event.type === "focusout" && $nextFocusTarget.length && $userAccountIcon.has($nextFocusTarget).length > 0) {
            return;
        }

        if ((event.type === "focusout" && $(".minicart").has(event.target).length > 0)
            || (event.type === "mouseleave" && $(event.target).is(".user"))) {
            event.stopPropagation();
            return;
        }

        if (event.type === "mouseleave" && $nextFocusTarget.length && $userAccountIcon.has($nextFocusTarget).length > 0) {
            return;
        }

        setPopoverState(false);
    });

    $accountPopoverLink.on("keydown", function (event) {
        if (isArrowDownKey(event)) {
            if (!$accountPopover.hasClass("show")) {
                setPopoverState(true);
            }

            if ($accountPopoverItems.length > 0) {
                event.preventDefault();
                $accountPopoverItems.first().focus();
            }
        } else if (isArrowUpKey(event)) {
            if (!$accountPopover.hasClass("show")) {
                setPopoverState(true);
            }

            if ($accountPopoverItems.length > 0) {
                event.preventDefault();
                $accountPopoverItems.last().focus();
            }
        }
    });

    $userAccountIcon.on("keydown", function (event) {
        let $target = $(event.target);

        if (isEscapeKey(event) && $accountPopover.hasClass("show")) {
            event.preventDefault();
            setPopoverState(false);
            $accountPopoverLink.first().focus();
            return;
        }

        if (!$target.is("a[role='menuitem']") || !$accountPopover.hasClass("show")) {
            return;
        }

        if (isArrowDownKey(event)) {
            event.preventDefault();
            let $nextItem = $target.closest("li").next().find("a[role='menuitem']");
            ($nextItem.length > 0 ? $nextItem : $accountPopoverItems.first()).focus();
        } else if (isArrowUpKey(event)) {
            event.preventDefault();
            let $previousItem = $target.closest("li").prev().find("a[role='menuitem']");
            ($previousItem.length > 0 ? $previousItem : $accountPopoverItems.last()).focus();
        }
    });
};

module.exports = {
    init: init
};
